import React, { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { Field } from "formik";
import { get, flatMap } from "lodash";
//import DocViewer,{DocViewerRenderers} from "react-doc-viewer";
import {
  CsplTable as Table,
  FieldInput,
  UploadComponent,
  FieldInputPercentage,
  FieldButtonGroup,
  FieldInputDollarBox,
  FieldDropSide,
  SearchableList,
  DatePicker,
  FieldInputNumber,
  ContentPreviewer,
  UploadComponentRollOver,
  FieldInputAlphabet,
  UploadComponentLoans,
} from "../../../components";
import {
  getSourceAndInvestmentAgainstSourceByPlanId,
  saveRolloverInRequest,
} from "../../../services";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import {
  usDateFormat,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  FLOW_TYPES,
} from "../../../utils";

const accountTypeOptions = [
  {
    label: "Saving Account",
    value: 1,
  },
  {
    label: "Checking Account",
    value: 2,
  },
];

const RollOverPlanDetailsContainer = (props) => {
  const {
    plans,
    selectedPlan,
    paymentOptions,
    formValues,
    setValues,
    fields,
    values,
    setFieldValue,
    handleChange,
    sourceValidations,
    sourceLevelContributionTableError,
    hasRothRollOverSource,
    setRothHasRollOverSource,
    requestId,
  } = props;
  const [showCheckLeaf, setShowCheckLeaf] = useState(false);
  const [showSpousalConsentForm, setShowSpousalConsentForm] = useState(false);
  const planId = selectedPlan;
  const sourceLevelInvestments = useRef([]);
  const isInvestmentAllocationsSameForAllSources = useRef([]);
  const { censusId } = useRouterParams();
  useDeepEffect(() => {
    setValues({ ...values, planId: planId });
    if (requestId == 0 || formValues !== 0)
      getSourceAndInvestmentAgainstSourceByPlanId(
        planId,
        parseInt(censusId, 10)
      )
        .then((response) => {
          const { isSuccessfull, ...rest } = response;
          if (response.isSuccessfull) {
            setFieldValue(`planDetails.${selectedPlan}`, {
              ...get(values, `planDetails.${selectedPlan}`),
              ...rest,
            });
            const isInvestmentAllocationsSameForAllSources = get(
              response,
              `isInvestmentAllocationsSameToAllSources`
            );
            setFieldValue(
              `isInvestmentAllocationsSameToAllSources`,
              isInvestmentAllocationsSameForAllSources
            );
            const sourceLevelInvestment = get(
              response,
              `sourceLevelInvestmentDetails`
            );
            if (isInvestmentAllocationsSameForAllSources)
              sourceLevelInvestments.current = [sourceLevelInvestment[0]];
            else sourceLevelInvestments.current = sourceLevelInvestment;
            // isInvestmentAllocationsSameForAllSources.current = get(
            //   response,
            //   `isInvestmentAllocationsSameToAllSources`
            // );
            let x = formValues === 0 ? response : formValues;
            // hasRollOverSource.current =
            //   formValues === 0
            //     ? response.rollOverSourceLevelContributions.some(
            //         (x) => x.sourceSubCategory === "EmployeeRothRollover"
            //       )
            //     : formValues.planDetails.hasRothRollOver;
            setFieldValue(
              `rollOverSourceLevelContributions`,
              get(x, `rollOverSourceLevelContributions`)
            );
            setFieldValue(
              `sourceLevelInvestments`,
              get(x, `sourceLevelInvestmentDetails`).map((x) =>
                x.investmentDetails.map((i) => {
                  return {
                    sourceId: x.sourceId,
                    sourceName: x.sourceName,
                    ...i,
                  };
                })
              )
            );
            //setIsLoading(false);
          } else {
            //setIsLoading(false);
          }
        })
        .catch(() => {
          //setIsLoading(false);
        });
  }, [selectedPlan, formValues]);
  const handleTotal = (sourceInd) => {
    let sum = 0;
    if (values.sourceLevelInvestments?.length > 0)
      get(values, `sourceLevelInvestments.${sourceInd}`, []).forEach(
        (x) =>
          (sum = ["", NaN, undefined, null].includes(x?.investmentPercentage)
            ? sum + 0
            : sum + x?.investmentPercentage)
      );
    return sum;
  };
  const handleTotalForAllSources = () => {
    let sum = 0;
    if (values.rollOverSourceLevelContributions?.length > 0)
      values.rollOverSourceLevelContributions.forEach((x) => {
        sum = ["", NaN, undefined, null].includes(x.contributionAmount)
          ? sum + 0
          : sum + x.contributionAmount;
        sum = ["", NaN, undefined, null].includes(x.earnings)
          ? sum + 0
          : sum + x.earnings;
      });
    return sum;
  };

  const handleDisableForRoth = () => {
    let initialValue = 0;
    const returnFlag =
      get(values, "rollOverSourceLevelContributions", [])
        .filter((x) => x.sourceSubCategory == "EmployeeRothRollover")
        .map(
          (_) =>
            parseFloat(_.contributionAmount) || 0 + parseFloat(_.earnings) || 0
        )
        .reduce(
          (accumulator, currentValue) =>
            parseFloat(accumulator) | parseFloat(currentValue),
          initialValue
        ) > 0;
    if (
      get(values, "rollOverSourceLevelContributions") &&
      values[fields.rothFirstContributionDate] &&
      !returnFlag
    ) {
      setFieldValue(fields.rothFirstContributionDate, null);
    }
    return returnFlag;
  };

  const handleTotalForSources = (sourceInd) => {
    let sum = 0;
    if (values.rollOverSourceLevelContributions?.length > 0) {
      let x = values.rollOverSourceLevelContributions[sourceInd];
      sum = ["", NaN, undefined, null].includes(x.contributionAmount)
        ? sum + 0
        : sum + x.contributionAmount;
      sum = ["", NaN, undefined, null].includes(x.earnings)
        ? sum + 0
        : sum + x.earnings;
    }
    return sum;
  };
  const onDaySelected = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };
  return (
    <div>
      <div className="rollover-plan-details-container">
        <div className="plan-details-header">Distributing Plan</div>
        <div className="line-separator" />
        <div className="plan-details-header">
          Previous plan and company Details
        </div>
        <div>
          <p className="mt-30 field-header">Plan name</p>
          <Row>
            <Col md="4">
              <Field
                size="lg"
                name={fields.planName}
                //label={"Plan name"}
                value={values[fields.planName]}
                onChange={handleChange}
                component={FieldInput}
                isRequired
              />
            </Col>
          </Row>
        </div>
        <div>
          <p className="field-header">Plan type</p>
          <Field
            isRequired
            //label="Type"
            name={fields.planType}
            //value={values[fields.planType]}
            value={values[fields.planType]}
            selectedValue={values[fields.planType]}
            direction="right"
            options={toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.PLAN_TYPES)}
            placeholder="-Select-"
            size="smdd"
            popupContent={
              <SearchableList
                label="Select a plan type"
                options={toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.PLAN_TYPES
                )}
                onSelect={(value) =>
                  // setValues({ ...values, [fields.type]: value })
                  setFieldValue(fields.planType, value)
                }
                selectedValue={values[fields.planType]}
              />
            }
            component={FieldDropSide}
          />
        </div>
        <div>
          <p className="field-header">Company name</p>
          <Row>
            <Col md="4">
              <Field
                size="smdd"
                name={fields.companyName}
                //label={"Company name"}
                value={values[fields.companyName]}
                onChange={handleChange}
                component={FieldInput}
                isRequired
              />
            </Col>
          </Row>
        </div>

        <p className="mt-30 plan-details-header">
          Previous Trustee / Custodian Details
        </p>
        <div>
          <p className="field-header">Trustee / Custodian name</p>
          <Row>
            <Col md="4">
              <Field
                size="smdd"
                name={fields.trusteeOrCustodianName}
                //label={"Trustee / Custodian name"}
                value={values[fields.trusteeOrCustodianName]}
                onChange={handleChange}
                component={FieldInputAlphabet}
                isRequired
              />
            </Col>
          </Row>
        </div>
        <div>
          <p className="field-header">Bank name</p>
          <Row>
            <Col md="4">
              <Field
                size="smdd"
                name={fields.custodianBankName}
                //label={"Trustee / Custodian name"}
                value={values[fields.custodianBankName]}
                onChange={handleChange}
                component={FieldInputAlphabet}
                isRequired
              />
            </Col>
          </Row>
        </div>
        <div>
          <p className="field-header">Custodial account number</p>
          <Row>
            <Col md="4">
              <Field
                size="smdd"
                name={fields.custodianAccountNumber}
                //label={"Trustee / Custodian name"}
                value={values[fields.custodianAccountNumber]}
                onChange={handleChange}
                min={0}
                max={999999999999999}
                component={FieldInputNumber}
                maxLength="15"
                isRequired
              />
            </Col>
          </Row>
        </div>
        <p className="mt-30 plan-details-header">Rollover Amount</p>
        <div>
          <p className="field-header">Enter rollover amount</p>
          <Row>
            <Col md="4">
              <Field
                size="xs"
                isRequired
                name={fields.rolloverAmount}
                //label="Enter rollover amount"
                value={values[fields.rolloverAmount]}
                onChange={handleChange}
                component={FieldInputDollarBox}
                type="number"
                autoComplete="off"
                min={0}
                max={9999999.99}
              />
            </Col>
          </Row>
        </div>

        <div className="sourcemapping-table">
          <ul style={{ listStyle: "none", paddingRight: "20px" }}>
            <li>
              <div className="row border-bottom mb-30">
                <p className="ft-16 ftwt-500 dark-grey ml-20">Source Mapping</p>
                <p className="ft-16 ftwt-500 dark-grey col-2">Contributions</p>
                <p className="ft-16 ftwt-500 dark-grey col-2">Earnings</p>
                <p className="ft-16 ftwt-500 dark-grey col-2">Total</p>
              </div>
            </li>
            {get(values, `rollOverSourceLevelContributions`, []).map(
              (data, index) => {
                var fieldName = `rollOverSourceLevelContributions.${index}.contributionAmount`;
                var earningName = `rollOverSourceLevelContributions.${index}.earnings`;
                return (
                  <li>
                    <div className="row border-bottom mb-30">
                      <p className="col-2 ft-16 dark-grey">{data.sourceName}</p>
                      <p>
                        <Field
                          size="xs"
                          isRequired
                          name={fieldName}
                          type="number"
                          autoComplete="off"
                          value={data.contributionAmount}
                          onChange={handleChange}
                          component={FieldInputDollarBox}
                          min={0}
                          max={9999999.99}
                        />
                      </p>
                      <div>
                        <Field
                          size="xs"
                          isRequired
                          name={earningName}
                          type="number"
                          autoComplete="off"
                          value={data.earning}
                          defaultValue={data.earnings}
                          onChange={handleChange}
                          component={FieldInputDollarBox}
                          min={0}
                          max={9999999.99}
                        />
                      </div>
                      <p className="dark-grey ft-16 col-2">
                        ${handleTotalForSources(index)}
                      </p>
                    </div>
                  </li>
                );
              }
            )}

            <li>
              <div className="w-90 row justifyContent mt-35">
                <p className="col-4 bold ft-16 dark-grey">
                  Total rollover amount
                </p>
                <p className="bold ft-16 dark-grey col-2">
                  ${handleTotalForAllSources()}
                </p>
              </div>
            </li>
          </ul>
        </div>
        <p className="rollOverErrorStyle">
          {sourceLevelContributionTableError}
        </p>
        <div>
          <p className="mt-50 field-header">First contribution day for Roth</p>
          <Row>
            <Col md="4">
              <Field
                size="smd"
                isRequired
                //label="Date range"
                name={fields.rothFirstContributionDate}
                value={usDateFormat(values[fields.rothFirstContributionDate])}
                isDatePicker
                direction="right"
                onClear={() =>
                  onDaySelected(fields.rothFirstContributionDate, null)
                }
                disabled={!handleDisableForRoth()}
                popupContent={
                  <DatePicker
                    onDayClick={(value) =>
                      onDaySelected(fields.rothFirstContributionDate, value)
                    }
                    value={usDateFormat(
                      values[fields.rothFirstContributionDate]
                    )}
                  />
                }
                component={FieldDropSide}
              />
            </Col>
          </Row>
        </div>

        <p className=" mt-30 plan-details-header">Choose transaction details</p>
        <div>
          <p className="field-header">Payment mode</p>
          <Row>
            <Col md="4">
              <Field
                isRequired
                //label="Payment mode"
                size="md"
                options={paymentOptions}
                name={fields.paymentMode}
                selectedValue={values[fields.paymentMode]}
                value={values[fields.paymentMode]}
                onChange={(value) => {
                  setFieldValue(fields.paymentMode, value);
                  setFieldValue(fields.financialInstitutionName, null);
                  setFieldValue(fields.chequeNumber, null);
                  setFieldValue(fields.routingNumber, null);
                  setFieldValue(fields.accountHolderName, null);
                  setFieldValue(fields.accountNumber, null);
                  setFieldValue(fields.accountType, null);
                }}
                component={FieldButtonGroup}
              />
            </Col>
          </Row>
        </div>

        {values[fields.paymentMode] === 1 ? (
          <Row>
            <Col>
              <div>
                <p className="field-header">Bank name</p>
                <Row>
                  <Col md="4">
                    <Field
                      size="smdd"
                      name={fields.financialInstitutionName}
                      //label={"financial Institution name"}
                      value={values[fields.financialInstitutionName]}
                      onChange={handleChange}
                      component={FieldInputAlphabet}
                      isRequired
                    />
                  </Col>
                </Row>
              </div>

              <div>
                <p className="field-header">Cheque number</p>
                <Row>
                  <Col md="4">
                    <Field
                      size="smdd"
                      isRequired
                      name={fields.chequeNumber}
                      //label="ChequeNumber"
                      value={values[fields.chequeNumber]}
                      onChange={handleChange}
                      component={FieldInputNumber}
                      type="number"
                      autoComplete="off"
                      min={0}
                      max={9999999999999999}
                    />
                  </Col>
                </Row>
              </div>

              <div>
                <p className="field-header">
                  Routing Number of Bank or Credit Union
                </p>
                <Row>
                  <Col md="4">
                    <Field
                      size="smdd"
                      name={fields.routingNumber}
                      //label={""}
                      value={values[fields.routingNumber]}
                      onChange={handleChange}
                      component={FieldInputNumber}
                      isRequired
                      min={0}
                      max={999999999}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        ) : null}

        {values[fields.paymentMode] === 2 ? (
          <Row>
            <Col>
              <div>
                <p className="field-header">Bank name</p>
                <Row>
                  <Col md="4">
                    <Field
                      size="smdd"
                      name={fields.financialInstitutionName}
                      //label={"financial Institution name"}
                      value={values[fields.financialInstitutionName]}
                      onChange={handleChange}
                      component={FieldInputAlphabet}
                      isRequired
                    />
                  </Col>
                </Row>
              </div>
              <div>
                <p className="field-header">Account Holder Name</p>
                <Row>
                  <Col md="4">
                    <Field
                      size="smdd"
                      name={fields.accountHolderName}
                      //label={""}
                      value={values[fields.accountHolderName]}
                      onChange={handleChange}
                      component={FieldInput}
                      isRequired
                    />
                  </Col>
                </Row>
              </div>

              <div>
                <p className="field-header">Account Type</p>
                <Row>
                  <Col md="4">
                    <Field
                      isRequired
                      //label="Account Type"
                      size="md"
                      options={accountTypeOptions}
                      selectedValue={values[fields.accountType]}
                      value={values[fields.accountType]}
                      name={fields.accountType}
                      onChange={(value) => {
                        setFieldValue(fields.accountType, value);
                      }}
                      component={FieldButtonGroup}
                    />
                  </Col>
                </Row>
              </div>

              <div>
                <p className="field-header">
                  Account Number (Checking or Saving Account)
                </p>
                <Row>
                  <Col md="4">
                    <Field
                      size="smdd"
                      name={fields.accountNumber}
                      //label={""}
                      value={values[fields.accountNumber]}
                      onChange={handleChange}
                      component={FieldInputNumber}
                      isRequired
                      min={0}
                      max={999999999999999999}
                    />
                  </Col>
                </Row>
              </div>

              <div>
                <p className="field-header">
                  Routing Number of Bank or Credit Union
                </p>
                <Row>
                  <Col md="4">
                    <Field
                      size="smdd"
                      name={fields.routingNumber}
                      //label={""}
                      value={values[fields.routingNumber]}
                      onChange={handleChange}
                      component={FieldInputNumber}
                      isRequired
                      min={0}
                      max={999999999}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        ) : null}

        <p className="upload-doc-container">Upload Documents</p>
        <div className="d-flex">
          <div className="upload-doc-container2 w-50">
            <p className="upload-doc-file">Check Leaf (if required)</p>
            <div className="d-flex">
              <p className="upload-doc-filetype mr-30">
                Accepted file : jpeg, png, jpg, pdf, word
              </p>
              <p className="upload-doc-filetype">Max File Size: 5 MB</p>
            </div>
          </div>
          <div className="w-50">
            <UploadComponentRollOver
              setFieldValue={setFieldValue}
              enablePreview={true}
              name={fields.checkLeaf}
              fileExtensions=".jpeg, .png, .jpg, .pdf"
              values={values}
              documentHidden={showCheckLeaf}
              fieldName={fields.checkLeaf}
              setDocumentHidden={setShowCheckLeaf}
            />
          </div>
        </div>
        {!showCheckLeaf && values[fields["checkLeaf"]]?.length > 0 && (
          <div>
            <ContentPreviewer
              data={
                values[fields["checkLeaf"]]?.[0]?.lastModified
                  ? URL.createObjectURL(values[fields["checkLeaf"]][0])
                  : values[fields["checkLeaf"]]?.[0]?.path
              }
            />
          </div>
        )}

        <div className="d-flex">
          <div className="upload-doc-container2 w-50">
            <p className="upload-doc-file">Spousal Consent Form</p>
            <div className="d-flex">
              <p className="upload-doc-filetype mr-30">
                Accepted file : jpeg, png, jpg, pdf, word
              </p>
              <p className="upload-doc-filetype">Max File Size: 5 MB</p>
            </div>
          </div>
          <div className="w-50">
            {/* <UploadComponentRollOver
              setFieldValue={setFieldValue}
              enablePreview={true}
              name={fields.spousalConsentForm}
              fileExtensions=".jpeg, .png, .jpg, .pdf"
              values={values}
              documentHidden={showSpousalConsentForm}
              fieldName={fields.spousalConsentForm}
              setDocumentHidden={setShowSpousalConsentForm}
            /> */}
            <UploadComponentRollOver
              setFieldValue={setFieldValue}
              enablePreview={true}
              name={fields.spousalConsentForm}
              fileExtensions=".jpeg, .png, .jpg, .pdf"
              values={values}
              documentHidden={showSpousalConsentForm}
              fieldName={fields.spousalConsentForm}
              setDocumentHidden={setShowSpousalConsentForm}
            />
          </div>
        </div>
        {!showSpousalConsentForm &&
          values[fields["spousalConsentForm"]]?.length > 0 && (
            <div>
              <ContentPreviewer
                data={
                  values[fields["spousalConsentForm"]]?.[0]?.lastModified
                    ? URL.createObjectURL(
                        values[fields["spousalConsentForm"]][0]
                      )
                    : values[fields["spousalConsentForm"]]?.[0]?.path
                }
              />
            </div>
          )}
      </div>
      {/* <DocViewer documents={docs} pluginRenderers={DocViewerRenderers} /> */}
      {sourceLevelInvestments.current.length > 0 &&
        sourceLevelInvestments.current.map((data, ind) => {
          return (
            <div>
              <p className="dark-grey ft-18 ftwt-500 mt-40">
                {values.isInvestmentAllocationsSameToAllSources
                  ? "Investment mapping"
                  : `Investment mapping by source - ${data?.sourceName}`}
              </p>
              <div className="w-90 sourcemapping-container">
                <ul style={{ listStyle: "none", paddingRight: "20px" }}>
                  <li>
                    <div className="row border-bottom mb-15">
                      <p className="plan-details-header">Investment name</p>
                      <p className="plan-details-header">Percentage</p>
                    </div>
                  </li>
                  <div></div>
                  {data?.investmentDetails.map((item, index) => {
                    const fieldName = `sourceLevelInvestments.${ind}.${index}.investmentPercentage`;
                    return (
                      <li>
                        <div className="row border-bottom mb-15">
                          <p className="dark-grey ft-16">
                            {item.investmentName}
                          </p>
                          <Field
                            size="xs"
                            isRequired
                            name={fieldName}
                            type="text"
                            autoComplete="off"
                            //value={data.percentage}
                            onChange={handleChange}
                            component={FieldInputPercentage}
                          />
                        </div>
                      </li>
                    );
                  })}

                  <li>
                    <div className="w-90 row justifyContent mt-25">
                      <p className="bold dark-grey ft-16">Total Percentage</p>
                      <p className="bold dark-grey ft-16">{handleTotal(ind)}</p>
                    </div>
                  </li>
                </ul>
              </div>
              <p className="rollOverErrorStyle">
                {sourceValidations && sourceValidations[ind]}
              </p>
            </div>
          );
        })}
    </div>
  );
};

export default RollOverPlanDetailsContainer;
